.lod-card {
  .content__second {
    .read-more {
      align-self: flex-start;
    }
  }
  &__description {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;

    #previous,
    #next {
      cursor: pointer;
    }

    p {
      margin: 0 !important;
    }

    a {
      align-self: flex-start;
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
      border-bottom-width: 1px;
      margin-left: 21px;
      cursor: pointer;

      &:before {
        content: url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5.61953C6.94352 5.61953 6.08696 6.47611 6.08696 7.5326C6.08696 8.58909 6.94352 9.44567 8 9.44567C9.05648 9.44567 9.91304 8.58909 9.91304 7.5326C9.91304 6.47611 9.05648 5.61953 8 5.61953ZM8.00023 7.05444C8.26376 7.05444 8.47849 7.26919 8.47849 7.53271C8.47849 7.79624 8.26376 8.01098 8.00023 8.01098C7.73671 8.01098 7.52197 7.79624 7.52197 7.53271C7.52197 7.26919 7.73671 7.05444 8.00023 7.05444ZM8 2C4.96257 2 2.5 4.4626 2.5 7.50008C2.5 11.4998 8 14.5 8 14.5C8 14.5 13.5 11.4998 13.5 7.50008C13.5 4.4626 11.0374 2 8 2ZM7.99979 3.43481C10.2414 3.43481 12.065 5.25845 12.065 7.50009C12.065 9.69629 9.5527 11.8059 7.99979 12.8237C6.44592 11.805 3.93457 9.69581 3.93457 7.50009C3.93457 5.25845 5.75818 3.43481 7.99979 3.43481Z" fill="%23001823"/><mask id="mask0_1026_20029" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="13"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5.61953C6.94352 5.61953 6.08696 6.47611 6.08696 7.5326C6.08696 8.58909 6.94352 9.44567 8 9.44567C9.05648 9.44567 9.91304 8.58909 9.91304 7.5326C9.91304 6.47611 9.05648 5.61953 8 5.61953ZM8.00023 7.05444C8.26376 7.05444 8.47849 7.26919 8.47849 7.53271C8.47849 7.79624 8.26376 8.01098 8.00023 8.01098C7.73671 8.01098 7.52197 7.79624 7.52197 7.53271C7.52197 7.26919 7.73671 7.05444 8.00023 7.05444ZM8 2C4.96257 2 2.5 4.4626 2.5 7.50008C2.5 11.4998 8 14.5 8 14.5C8 14.5 13.5 11.4998 13.5 7.50008C13.5 4.4626 11.0374 2 8 2ZM7.99979 3.43481C10.2414 3.43481 12.065 5.25845 12.065 7.50009C12.065 9.69629 9.5527 11.8059 7.99979 12.8237C6.44592 11.805 3.93457 9.69581 3.93457 7.50009C3.93457 5.25845 5.75818 3.43481 7.99979 3.43481Z" fill="white"/></mask><g mask="url(%23mask0_1026_20029)"></g></svg>');
        width: 16px;
        height: 16px;
        margin-left: 0;
        border-bottom: 0;
        position: absolute;
        vertical-align: -50%;
        left: -21px;
        padding-top: 1px;
      }
    }

    time {
      align-self: flex-start;
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
      border-bottom-width: 1px;
      margin-left: 21px;
      cursor: pointer;

      &:before {
        content: url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.28 9.21974C10.573 9.51274 10.573 9.98724 10.28 10.2802C10.1335 10.4267 9.94151 10.5002 9.74951 10.5002C9.55801 10.5002 9.36601 10.4267 9.21951 10.2802L7.47051 8.53124C7.40051 8.46124 7.34451 8.37774 7.30651 8.28474C7.30501 8.28124 7.30451 8.27774 7.30301 8.27374C7.26951 8.18874 7.24951 8.09674 7.24951 8.00024V4.50024C7.24951 4.08574 7.58551 3.75024 7.99951 3.75024C8.41401 3.75024 8.74951 4.08574 8.74951 4.50024V7.68924L10.28 9.21974ZM7.99951 13.5002C4.96701 13.5002 2.49951 11.0327 2.49951 8.00024C2.49951 4.96724 4.96701 2.50024 7.99951 2.50024C11.0325 2.50024 13.4995 4.96724 13.4995 8.00024C13.4995 11.0327 11.0325 13.5002 7.99951 13.5002ZM7.99951 1.00024C4.13401 1.00024 0.999512 4.13424 0.999512 8.00024C0.999512 11.8662 4.13401 15.0002 7.99951 15.0002C11.866 15.0002 14.9995 11.8662 14.9995 8.00024C14.9995 4.13424 11.866 1.00024 7.99951 1.00024Z" fill="%23001823"/><mask id="mask0_1055_482" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="15" height="15"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.28 9.21974C10.573 9.51274 10.573 9.98724 10.28 10.2802C10.1335 10.4267 9.94151 10.5002 9.74951 10.5002C9.55801 10.5002 9.36601 10.4267 9.21951 10.2802L7.47051 8.53124C7.40051 8.46124 7.34451 8.37774 7.30651 8.28474C7.30501 8.28124 7.30451 8.27774 7.30301 8.27374C7.26951 8.18874 7.24951 8.09674 7.24951 8.00024V4.50024C7.24951 4.08574 7.58551 3.75024 7.99951 3.75024C8.41401 3.75024 8.74951 4.08574 8.74951 4.50024V7.68924L10.28 9.21974ZM7.99951 13.5002C4.96701 13.5002 2.49951 11.0327 2.49951 8.00024C2.49951 4.96724 4.96701 2.50024 7.99951 2.50024C11.0325 2.50024 13.4995 4.96724 13.4995 8.00024C13.4995 11.0327 11.0325 13.5002 7.99951 13.5002ZM7.99951 1.00024C4.13401 1.00024 0.999512 4.13424 0.999512 8.00024C0.999512 11.8662 4.13401 15.0002 7.99951 15.0002C11.866 15.0002 14.9995 11.8662 14.9995 8.00024C14.9995 4.13424 11.866 1.00024 7.99951 1.00024Z" fill="white"/></mask><g mask="url(%23mask0_1055_482)"></g></svg>');
        width: 16px;
        height: 16px;
        margin-left: 0;
        border-bottom: 0;
        position: absolute;
        vertical-align: -50%;
        left: 0;
        padding-top: 3px;
      }
    }
  }
}
